import { msg } from '@lingui/core/macro';
import type { I18n, MessageDescriptor } from '@lingui/core';

// ---------------------------------------------------------------------------
// Registry of translatable expiry threshold preset labels.
// Keyed by `context:message` to avoid collisions when the same message string
// is used with different contexts.
// ---------------------------------------------------------------------------

function presetKey(context: string | undefined, message: string): string {
  return `${context ?? ''}:${message}`;
}

const presetLabels: Record<string, MessageDescriptor> = {
  [presetKey('expiry_preset', '1 day')]: msg({ message: '1 day', context: 'expiry_preset' }),
  [presetKey('expiry_preset', '2 days')]: msg({ message: '2 days', context: 'expiry_preset' }),
  [presetKey('expiry_preset', '3 days')]: msg({ message: '3 days', context: 'expiry_preset' }),
  [presetKey('expiry_preset', '5 days')]: msg({ message: '5 days', context: 'expiry_preset' }),
  [presetKey('expiry_preset', '1 week')]: msg({ message: '1 week', context: 'expiry_preset' }),
  [presetKey('expiry_preset', '2 weeks')]: msg({ message: '2 weeks', context: 'expiry_preset' }),
  [presetKey('expiry_preset', '1 month')]: msg({ message: '1 month', context: 'expiry_preset' }),
};

/**
 * Translate an expiry threshold preset label.
 * Falls back to the raw message string if no translation is found.
 */
export function translatePresetLabel(
  i18n: I18n,
  label: { message: string; context?: string }
): string {
  const descriptor = presetLabels[presetKey(label.context, label.message)];
  if (descriptor) {
    return i18n._(descriptor);
  }
  return label.message;
}
